/**
 * Used to tell if our code is running on the server or client.
 * @returns {Boolean} True if we're server-side.
 */
const isServer = typeof window === 'undefined';

export default isServer;
